import { render } from "./addMouldModel.vue?vue&type=template&id=5559a712"
import script from "./addMouldModel.vue?vue&type=script&lang=js"
export * from "./addMouldModel.vue?vue&type=script&lang=js"

import "./addMouldModel.vue?vue&type=style&index=0&id=5559a712&lang=scss"

import exportComponent from "D:\\companyProject\\G10Product\\trunk\\Bestech.CloudPos\\Bestech.CloudPos.Portal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__